/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditorunnameddish3Inputs */

const en_menueditorunnameddish3 = /** @type {(inputs: Menueditorunnameddish3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unnamed dish`)
};

const de_menueditorunnameddish3 = /** @type {(inputs: Menueditorunnameddish3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gericht ohne Namen`)
};

/**
* | output |
* | --- |
* | "Unnamed dish" |
*
* @param {Menueditorunnameddish3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditorunnameddish3 = /** @type {((inputs?: Menueditorunnameddish3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditorunnameddish3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditorunnameddish3(inputs)
	return de_menueditorunnameddish3(inputs)
});
export { menueditorunnameddish3 as "menuEditorUnnamedDish" }